export default "__VITE_ASSET__Cz7ZJWB9__"